
const BackColor = '#fff';
const SecondaryBackColor = '#fafbed';

const TextColor = '#000';
const SecondaryTextColor = '#b8c500';
const ImpressumTextColor = '#AAAAAA';

const ActionColor = '#0f0';
const ActionShadeColor = '#00f000';
const ActionTextColor = '#fff';

export {
  ActionColor,
  ActionShadeColor,
  ActionTextColor,
  BackColor,
  ImpressumTextColor,
  SecondaryBackColor,
  SecondaryTextColor,
  TextColor,
};



// WEBPACK FOOTER //
// ./src/components/styles/colors.js